import { SelectProps } from '@radix-ui/react-select';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/Select';

import { useAuth } from '@/contexts/AuthContext';
import i18n from '@/lib/i18n';

interface CustomerLanguageSelectorProps extends SelectProps {}

export function CustomerLanguageSelector(props: CustomerLanguageSelectorProps) {
  const { user } = useAuth();

  const langs = [
    user?.customer?.seoLanguage,
    user?.customer?.language,
    ...(user?.customer?.additionalSeoLanguage ?? []),
  ].filter((lang) => lang !== undefined);

  const uniqueLangs = Array.from(new Set(langs));

  return (
    <Select {...props}>
      <SelectTrigger id="language">
        <SelectValue
          placeholder={i18n.t(
            'components.CustomerLanguageSelector.placeholder',
          )}
        />
      </SelectTrigger>

      <SelectContent>
        {uniqueLangs.map((customerLanguage) => (
          <SelectItem key={customerLanguage} value={customerLanguage}>
            {customerLanguage}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
